var map = {
	"./icon-30-day.svg": "./src/assets/icons/icon-30-day.svg",
	"./icon-arrow--cta-left.svg": "./src/assets/icons/icon-arrow--cta-left.svg",
	"./icon-arrow--cta.svg": "./src/assets/icons/icon-arrow--cta.svg",
	"./icon-arrow--down.svg": "./src/assets/icons/icon-arrow--down.svg",
	"./icon-arrow--left.svg": "./src/assets/icons/icon-arrow--left.svg",
	"./icon-arrow--right.svg": "./src/assets/icons/icon-arrow--right.svg",
	"./icon-arrow--up.svg": "./src/assets/icons/icon-arrow--up.svg",
	"./icon-carousel-arrow--left.svg": "./src/assets/icons/icon-carousel-arrow--left.svg",
	"./icon-carousel-arrow--right.svg": "./src/assets/icons/icon-carousel-arrow--right.svg",
	"./icon-cart.svg": "./src/assets/icons/icon-cart.svg",
	"./icon-check.svg": "./src/assets/icons/icon-check.svg",
	"./icon-close.svg": "./src/assets/icons/icon-close.svg",
	"./icon-flag--canada.svg": "./src/assets/icons/icon-flag--canada.svg",
	"./icon-flag--usa.svg": "./src/assets/icons/icon-flag--usa.svg",
	"./icon-guarantee-check.svg": "./src/assets/icons/icon-guarantee-check.svg",
	"./icon-lock.svg": "./src/assets/icons/icon-lock.svg",
	"./icon-minus.svg": "./src/assets/icons/icon-minus.svg",
	"./icon-play.svg": "./src/assets/icons/icon-play.svg",
	"./icon-plus.svg": "./src/assets/icons/icon-plus.svg",
	"./icon-quotation-mark--left.svg": "./src/assets/icons/icon-quotation-mark--left.svg",
	"./icon-quotation-mark--right.svg": "./src/assets/icons/icon-quotation-mark--right.svg",
	"./icon-search.svg": "./src/assets/icons/icon-search.svg",
	"./icon-star-rating.svg": "./src/assets/icons/icon-star-rating.svg",
	"./icon-store.svg": "./src/assets/icons/icon-store.svg",
	"./icon-undo.svg": "./src/assets/icons/icon-undo.svg",
	"./icon-warning.svg": "./src/assets/icons/icon-warning.svg",
	"./product-icons/icon-fair-trade-chocolate.svg": "./src/assets/icons/product-icons/icon-fair-trade-chocolate.svg",
	"./product-icons/icon-gluten-free.svg": "./src/assets/icons/product-icons/icon-gluten-free.svg",
	"./product-icons/icon-guarantee.svg": "./src/assets/icons/product-icons/icon-guarantee.svg",
	"./product-icons/icon-keto.svg": "./src/assets/icons/product-icons/icon-keto.svg",
	"./product-icons/icon-soy-free.svg": "./src/assets/icons/product-icons/icon-soy-free.svg",
	"./product-icons/icon-vegan.svg": "./src/assets/icons/product-icons/icon-vegan.svg",
	"./social-icons/icon-email.svg": "./src/assets/icons/social-icons/icon-email.svg",
	"./social-icons/icon-facebook-f.svg": "./src/assets/icons/social-icons/icon-facebook-f.svg",
	"./social-icons/icon-facebook.svg": "./src/assets/icons/social-icons/icon-facebook.svg",
	"./social-icons/icon-instagram.svg": "./src/assets/icons/social-icons/icon-instagram.svg",
	"./social-icons/icon-pinterest.svg": "./src/assets/icons/social-icons/icon-pinterest.svg",
	"./social-icons/icon-rss.svg": "./src/assets/icons/social-icons/icon-rss.svg",
	"./social-icons/icon-shopify-logo.svg": "./src/assets/icons/social-icons/icon-shopify-logo.svg",
	"./social-icons/icon-snapchat.svg": "./src/assets/icons/social-icons/icon-snapchat.svg",
	"./social-icons/icon-tumblr.svg": "./src/assets/icons/social-icons/icon-tumblr.svg",
	"./social-icons/icon-twitter.svg": "./src/assets/icons/social-icons/icon-twitter.svg",
	"./social-icons/icon-vimeo.svg": "./src/assets/icons/social-icons/icon-vimeo.svg",
	"./social-icons/icon-youtube.svg": "./src/assets/icons/social-icons/icon-youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive \\.svg$";